import axios from "axios";
import React, { useState } from "react";
import { api_url } from "../../url";
import { toast } from "react-toastify";

export default function MemberForm() {
  const [formData, setFormData] = useState({});

  const [preview, setPreview] = useState("");

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files && files[0];

      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));

      if (file) {
        setPreview(URL.createObjectURL(file));
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      // append all fields
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      const res = await axios.post(
        `${api_url}/api/v1/icsaj/create/member`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      toast.success(res.data.message);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="container my-5">
      <div className="form-card p-4 shadow">
        <h2 className="text-center mb-4">Advocate Registration Form</h2>

        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Passport Photo */}

            <div className="col-12 mb-3">
              {preview && <img src={preview} width="200" />}

              <label>Passport Size Photo</label>
              <input
                type="file"
                name="photo"
                className="form-control"
                onChange={handleChange}
                accept="image/*"
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="name"
                placeholder="Name (Block Letters)"
                className="form-control"
                required
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="fatherName"
                placeholder="Father’s / Husband’s Name"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4 mb-3">
              <input
                type="date"
                name="dob"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-8 mb-3">
              <input
                type="text"
                name="barCouncil"
                placeholder="Bar Council - Enrolment No & Date"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="graduation"
                placeholder="Year of Graduation & Institute"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="law"
                placeholder="Law Passing Year & University"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-12 mb-3">
              <input
                type="text"
                name="practicePlace"
                placeholder="Place of Practicing"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            {/* Address */}
            <div className="col-md-6 mb-3">
              <textarea
                name="presentAddress"
                placeholder="Present Address"
                className="form-control"
                rows="3"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-md-6 mb-3">
              <textarea
                name="permanentAddress"
                placeholder="Permanent Address"
                className="form-control"
                rows="3"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-12 mb-3">
              <textarea
                name="officeAddress"
                placeholder="Office Address"
                className="form-control"
                rows="2"
                onChange={handleChange}
              ></textarea>
            </div>

            {/* Contact */}
            <div className="col-md-4 mb-3">
              <input
                type="text"
                name="telephone"
                placeholder="Telephone"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4 mb-3">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4 mb-3">
              <input
                type="text"
                name="phone"
                placeholder="phone Number"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4 mb-3">
              <input
                type="text"
                name="blood"
                placeholder="Blood Group"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-12 mb-3">
              <textarea
                name="caseDetails"
                placeholder="Any case pending? (Details)"
                className="form-control"
                rows="3"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-12 mb-3">
              <textarea
                name="retiredDetails"
                placeholder="Retired from Judicial Services? (Details)"
                className="form-control"
                rows="3"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="aadhar"
                placeholder="Aadhar Card Number"
                className="form-control"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <input
                type="text"
                name="voter"
                placeholder="Election ID Card Number"
                className="form-control"
                onChange={handleChange}
              />
            </div>
          </div>

          <button className="btn btn-danger w-100 mt-3">
            Submit Application
          </button>
        </form>
      </div>
    </div>
  );
}
